<div
  bsModal
  #modal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-{{size}}" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          (click)="onClickClose()"
          class="close"
          data-dismiss="modal"
          aria-label="Fechar"
          *ngIf="!hideClose"
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <h4 class="pull-left modal-title">{{title}}</h4>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-xs-12">
            <ng-content></ng-content>
          </div>
        </div>
      </div>

      <div class="modal-footer" *ngIf="!hideButtons">
        <button
          *ngIf="!hideClose"
          type="button"
          class="btn btn-border-orange pull-left"
          data-dismiss="modal"
          (click)="onClickClose()"
        >{{labelClose}}</button>

        <button
          *ngIf="!hideOk"
          type="button"
          class="btn btn-full-orange pull-right"
          (click)="onClickOk()"
          data-dismiss="modal"
          [disabled]="disabledOk"
        >{{labelOk}}</button>
      </div>
    </div>
  </div>
</div>

<app-modal-message #modalMessage title="ATENÇÃO" message="{{message}}" size="md" labelClose="Não" labelOk="Sim"></app-modal-message>
